import { Moon, Sun } from 'lucide-react';
import { cn } from '@/shared/lib/utils/cn';
import { useTheme } from './useTheme';

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      className={cn(
        'rounded-full p-2 text-muted-foreground transition-all hover:bg-zinc-100 hover:text-foreground dark:hover:bg-zinc-800',
        className,
      )}
    >
      {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
